import type { CSSProperties } from 'react'

/*
 * Where a React Flow canvas puts its arrange button and its zoom/fit column. Both float over the
 * canvas's bottom-right corner, where the AI assistant button also floats (40px, by default 24px
 * from the right and 80px from the bottom, see the AI store's fabPosition) above the console bar.
 * The zoom/fit column sits right on top of the AI button, clear of the console, and the arrange
 * button on top of the column.
 */

/** From the canvas's bottom edge to the bottom of the zoom/fit column. */
const AI_FAB_CLEARANCE = 80 + 40 - 2
/** React Flow control buttons are 26px; zoom in, zoom out and fit view make the column. */
const CONTROLS_COLUMN_HEIGHT = 3 * 26
const ARRANGE_GAP = 6

/** For the canvas's `Controls`. */
export const CANVAS_CONTROLS_STYLE: CSSProperties = { marginBottom: AI_FAB_CLEARANCE }

/** For the `Panel` holding the arrange button, right above the zoom/fit column. */
export const LAYOUT_TOOLS_PANEL_STYLE: CSSProperties = {
  marginBottom: AI_FAB_CLEARANCE + CONTROLS_COLUMN_HEIGHT + ARRANGE_GAP,
}

// The designer loads React Flow's base.css, which has no disabled button styles
export const LAYOUT_TOOL_BUTTON_CLASS_NAME = 'disabled:opacity-40 disabled:cursor-not-allowed'
